// extracted by mini-css-extract-plugin
module.exports = {"headline":"H3_headline__3wPYq"};